export interface MenuPermissionRequirement {
  container: string
  action: string
}

export interface MenuVisibilityContext {
  permissionsLoaded: boolean
  can: (requirement: MenuPermissionRequirement) => boolean
}

// Same rule as `can()` and the page middleware: until the licence permissions are known, a gated entry stays
// hidden. Showing it optimistically made entries the user lacks (typically Plugins) appear behind the licence
// picker and vanish once the permissions arrived.
export const isAllowedByMenuPermissions = (
  requiredPermissions: readonly MenuPermissionRequirement[] | undefined,
  context: MenuVisibilityContext
): boolean => {
  if (!requiredPermissions || requiredPermissions.length === 0) return true
  if (!context.permissionsLoaded) return false
  return requiredPermissions.some((requirement) => context.can(requirement))
}
